import {
  getUserNotificationSetting,
  updateUserNotificationSetting,
  deleteUserAccount,
} from "../../utils/apiClient";

export const fetchEmailNotificationSetting = async () => {
  const response = await getUserNotificationSetting();
  const data = response?.decryptedData ?? response?.data ?? {};
  return {
    code: Number(data?.CODE),
    emailEnabled: Number(data?.EMAIL) === 1 || data?.EMAIL === true,
    message: data?.MESSAGE || "",
  };
};

export const saveEmailNotificationSetting = async (emailEnabled) => {
  const response = await updateUserNotificationSetting(emailEnabled);
  const data = response?.decryptedData ?? response?.data ?? {};
  return {
    code: Number(data?.CODE),
    message: data?.MESSAGE || "",
  };
};

export const requestDeleteAccount = async (pin) => {
  const response = await deleteUserAccount(pin);
  const data = response?.decryptedData ?? response?.data ?? {};
  return {
    code: Number(data?.CODE),
    message: data?.MESSAGE || "",
  };
};

const securitySettingsController = {
  fetchEmailNotificationSetting,
  saveEmailNotificationSetting,
  requestDeleteAccount,
};

export default securitySettingsController;
